export default __webpack_public_path__ + "static/logo-72758879a2b97b200a173fc62ee9170d.png";